import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b54cc1da&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b54cc1da&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=b54cc1da&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54cc1da",
  null
  
)

export default component.exports